import { MatDialogConfig } from '@angular/material/dialog';

/**
 * App-wide defaults for MAT_DIALOG_DEFAULT_OPTIONS.
 *
 * MatDialog.open() does `{ ...(defaultOptions || new MatDialogConfig()), ...config }`, so a partial
 * object here REPLACES Material's defaults instead of overriding them. Without the spread,
 * autoFocus / restoreFocus / delayFocusTrap / role are undefined inside every dialog container:
 * no dialog takes keyboard focus on open, none returns it on close, and none has role="dialog"
 * (#33607, WCAG 2.4.3).
 */
export const ACHIEVE_DIALOG_DEFAULT_OPTIONS: MatDialogConfig = {
  ...new MatDialogConfig(),
  disableClose: true,
  hasBackdrop: true,
};
